import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "@/plugins/bootstrap-vue";
import "@/plugins/vee-validate";
import VueRamUtils from "vue-ram-utils";
import "vue-ram-utils/dist/vue-ram-utils.css";
import DatePicker from "vue2-datepicker";

import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/it";

Vue.use(VueRamUtils);
Vue.use(DatePicker)

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
